import React from "react";
import styled from "styled-components/macro";
import { Stack, IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@duocards/pro-regular-svg-icons";
import HamburgerMenu from "./HamburgerMenu";
import { Trans } from "react-i18next";
import { PracticeIcon } from "root/practice/PracticeIcon";
import { getPracticeOptionByMode } from "root/practice/practiceOptions";
import type { AssistantMode } from "components/assistant/__generated__/AssistantMutation.graphql";

const Wrap = styled(Stack)`
  align-items: center;
  border-bottom: 1px solid ${(p) => p.theme.duo.color.lightGrey};
  background-color: white;
  flex-grow: 0;
  min-height: 56px;
  justify-content: space-between;
  padding: 0 8px;
`;

const SBackButton = styled(IconButton)`
  margin: 6px;
  color: ${(p) => p.theme.duo.color.text};
  svg {
    width: 16px;
    height: 16px;
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

const SHamburgerMenu = styled(HamburgerMenu)``;

const Title = styled.div`
  font-size: 90%;
  font-weight: 700;
  color: ${(p) => p.theme.duo.color.text};
  text-transform: uppercase;
`;

type Props = {
  mode: AssistantMode;
  onBack: () => void;
  className?: string;
};

const AssistantMenu: React.FC<Props> = ({ mode, onBack, className }) => {
  const meta = getPracticeOptionByMode(mode);

  if (!meta) return null;

  return (
    <Wrap direction="row" className={className}>
      <SBackButton onClick={onBack} aria-label="back">
        <FontAwesomeIcon icon={faChevronLeft} />
      </SBackButton>

      <Content>
        <PracticeIcon icon={meta.icon} size="medium" />
        <Title>
          <Trans>{meta.title}</Trans>
        </Title>
      </Content>
      <SHamburgerMenu mode={mode} />
    </Wrap>
  );
};

export default AssistantMenu;
